export const TTV_EDITOR_PATH = "/text-to-vocals";
